export default __webpack_public_path__ + "a032650623e12e66b1f7283f5063a2d0.svg";